import { Grid } from '@mantine/core';
import type { UseFormReturn } from 'react-hook-form';
import { Show } from '../../../../../../../react-commons/components/control-flow/Show';
import type { FormNames } from '../../../../../../../react-commons/utils/form/getFormNames';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    ActivitiesPropertyValidation,
    type ActivitiesResource,
} from '../../../../../resource/resources/artifacts/activities/activitiesResource';
import { PropertyInputs } from '../../../../reusable-components/base/property-bases/PropertyInputs';
import type { PropertyValidationInformation } from '../../../../util/PropertyValidationInformation';

export const ActivityContent = ({
    id,
    form,
    formNames,
    readOnly,
    displayedInOverview,
}: {
    id?: string;
    form: UseFormReturn<ActivitiesResource>;
    formNames: FormNames<ActivitiesResource>;
    readOnly: boolean;
    displayedInOverview?: boolean;
}) => {
    const getPropertyValidationInformation = (
        propertyIdentifier: ActivitiesPropertyValidation
    ): PropertyValidationInformation => ({
        resourceId: id,
        resourceType: ResourceType.ACTIVITIES,
        propertyIdentifier,
    });

    return (
        <Grid>
            <Show when={!displayedInOverview}>
                <Grid.Col span={12}>
                    <PropertyInputs.Name
                        name={formNames.name}
                        control={form.control}
                        readOnly={readOnly}
                        propertyValidationInformation={getPropertyValidationInformation(
                            ActivitiesPropertyValidation.NAME
                        )}
                    />
                </Grid.Col>
            </Show>
            <Grid.Col span={12}>
                <PropertyInputs.MultilineString
                    name={formNames.description}
                    control={form.control}
                    nullable={false}
                    readOnly={readOnly}
                    propertyValidationInformation={getPropertyValidationInformation(
                        ActivitiesPropertyValidation.DESCRIPTION
                    )}
                />
            </Grid.Col>
        </Grid>
    );
};
